import { ApplicationForm } from './ApplicationForm'
import { Box, Typography } from '@mui/material'
import { Navbar } from '../../../components/Navbar'
import { Footer } from '../../../components/Footer'
import { PageContainer } from '../../../components/styled/PageContainer'
import { Helmet } from 'react-helmet'
import { useEffect } from 'react'

export const RHWarrantyForm = () => {
  // Scroll to top on page load
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <Box>
      <Helmet>
        <title>Road Hazard Warranty Campaign Register</title>
      </Helmet>
      <Navbar />
      <PageContainer>
        <Box mt={8} mb={4} sx={{ px: { xs: 3, sm: 10, md: 18 }, pb: 5 }}>
          <Box mb={8}>
            <Typography variant='h4' fontWeight={'bold'} mb={2} style={{ color: '#321151' }}>
              Road Hazard Warranty Campaign
            </Typography>
            <Typography variant='h4' fontWeight={'bold'} mb={2} style={{ color: '#321151' }}>
              Registration Form
            </Typography>
          </Box>
          <ApplicationForm />
        </Box>
      </PageContainer>
      <Footer />
    </Box>
  )
}
